import { COLORS } from '@/styles/colors';
import { bodySmall, poppinsRegularFont } from '@/styles/typography';
import styled from 'styled-components';

export const PaymentDetailsSubtitle = styled.div`
  ${poppinsRegularFont};
  ${bodySmall};
  color: ${COLORS.grey[600]};
  margin-bottom: 28px;
`;
